import womanAtDesk from "../assets/v2/why-choose-woman-at-desk.webp";
import iconNoCollateral from "../assets/v2/benefit-icon-no-collateral.webp";
import iconInstantApproval from "../assets/v2/benefit-icon-instant-approval.webp";
import iconSecure from "../assets/v2/benefit-icon-secure.webp";
import iconSupport from "../assets/v2/benefit-icon-support.webp";

const BENEFITS = [
  {
    icon: iconNoCollateral,
    title: "No collateral required",
    description: "Get approved based on your creditworthiness alone. No property or assets needed.",
  },
  {
    icon: iconInstantApproval,
    title: "Instant approval",
    description: "Get money in your account within 15 minutes of approval. No waiting around.",
  },
  {
    icon: iconSecure,
    title: "Secure Process",
    description: "Your personal and financial data is fully secured with bank-grade encryption.",
  },
  {
    icon: iconSupport,
    title: "24/7 Support",
    description: "Complete everything from your phone. No paperwork, no branch visits required.",
  },
];

const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="scroll-mt-24 bg-ep-ivory py-20 lg:pb-[82px] lg:pt-[104px]" aria-labelledby="why-choose-us-title">
      <div className="page-container">
        {/* Header */}
        <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
          <h2 id="why-choose-us-title" className="ep-section-title text-ep-green">
            Why choose EazyPaisa?
          </h2>
          <p className="max-w-[420px] text-base leading-[1.75] text-ep-muted lg:mt-1 lg:text-[17px]">
            Join 50,000+ satisfied customers who trust us for quick, hassle-free loans
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:mt-[68px] lg:grid-cols-[34.3%_minmax(0,1fr)] lg:gap-16">
          <img
            src={womanAtDesk}
            alt="A woman smiling as she writes in a notebook at her desk"
            className="hidden h-full min-h-[560px] w-full rounded-xl border border-[#526A5E] object-cover lg:block"
            width={896}
            height={1200}
            loading="lazy"
          />

          <ul className="grid gap-6 sm:grid-cols-2 lg:gap-8">
            {BENEFITS.map((item) => (
              <li
                key={item.title}
                className="flex flex-col items-center rounded-xl border border-ep-border bg-white px-8 pb-12 pt-12 text-center lg:min-h-[339px] lg:pt-[54px]"
              >
                <img src={item.icon} alt="" aria-hidden width={32} height={32} className="h-8 w-8" loading="lazy" />
                <h3 className="mt-10 font-serif text-[28px] font-normal leading-tight text-ep-green lg:mt-12 lg:text-[30px]">
                  {item.title}
                </h3>
                <p className="mt-4 max-w-[310px] text-[15px] leading-[1.75] text-ep-muted">
                  {item.description}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
